import { DatePicker, Form } from "antd";
import React from "react";
import { useState } from "react";
import { ReactComponent as CalendarIcon } from "../../../assets/icons/calendar-icon.svg";
import { getRequest } from "../../../http/axiosConfig/config";
import urls from "../../../http/endpoints/urls";
import moment from "moment"; // Import moment for date manipulation
import { Select } from "antd";

export default function MyOrders() {
  let customerId = localStorage.getItem("userId");
  const [dateForm] = Form.useForm();
  const [date, setDate] = useState(null);
  const [selectOptions, setSelectOptions] = useState([]);
  const [rows, setRows] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);

  const disableDatesOutsideRange = (current) => {
    const aprilFirst2025 = moment("2025-04-01").startOf("day");
    const today = moment().endOf("day"); // Important change

    return (
      current &&
      (current.isBefore(aprilFirst2025) || current.isAfter(today))
    );
  };


  return (
    <div>
      <div className="page-header">My Orders</div>
      <Form
        className="date-range-form"
        form={dateForm}
        layout={"horizontal"}
        requiredMark={false}
        style={{ marginTop: 10, marginBottom: 10 }}
      >
        <Form.Item
          noStyle
          name={"fromDate"}
          rules={[{ required: true, message: "Please select from date" }]}
        >
          <DatePicker
            suffixIcon={<CalendarIcon />}
            format="DD/MM/YY"
            disabledDate={disableDatesOutsideRange}
            onChange={async (e) => {
              setSelectOptions([]);
              setRows([]);
              setSelectedValue(null);
              try {
                setDate(e._d);
                const formattedDate = moment(e._d).format("DD-MMM-YY");
                const response = await getRequest(
                  urls.customerIndentNumbers(customerId, formattedDate)
                );

                setSelectOptions(response);
              } catch (error) {
                console.error("Error fetching data:", error);
              }
            }}
          />
        </Form.Item>

        <Form.Item
          noStyle
          name={"batch"}
          rules={[{ required: true, message: "Please select to Batch" }]}
        >
          <Select
            name="select-batches"
            placeholder="Drop Down"
            style={{ width: "169px" }}
            value={selectedValue}
            onChange={async (val) => {
              setSelectedValue(val);
              setRows([]);
              try {
                const response = await getRequest(urls.customerIndentView(val));
                setRows(
                  response?.[0]?.map((item, index) => ({
                    ...item,
                    key: index,
                  }))
                );
              } catch (error) {
                console.log(error);
              }
            }}
            // value={selectedStatus}
            disabled={selectOptions.length === 0}
          >
            {selectOptions.map((option) => (
              <Select.Option
                key={option.INDENT_NUMBER}
                value={option.INDENT_NUMBER}
              >
                {option.ROUTE}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>

      <div
        style={{
          fontFamily: "Arial, sans-serif",
          height: "350px",
          overflow: "auto",
        }}
      >
        <div
          style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "10px" }}
        >
          {rows && rows.length > 0
            ? `Order Value: ${rows
              .reduce((acc, item) => acc + (parseFloat(item.AMOUNT) || 0), 0)
              .toFixed(2)}.`
            : "Order Value: 0"}
        </div>
        {/* {rows.map((item) => (
          <table
            key={item.key}
            style={{
              width: "100%",
              borderCollapse: "collapse",
              overflow: "auto",
              border: "3px solid #ddd",
              marginBottom: "20px",
            }}
          >
            <thead>
              <tr
                style={{
                  backgroundColor: "#f8f8f8",
                  borderBottom: "2px solid #ddd",
                }}
              >
                <th
                  colSpan={4}
                  style={{
                    padding: "5px",
                    textAlign: "left",
                    fontSize: "11px",
                    textAlign: "center",
                  }}
                >
                  Packet Name: {item.PACKET_NAME}
                </th>
              </tr>
            </thead>
            <tbody style={{ overflow: "auto" }}>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td
                  style={{
                    padding: "5px",
                    color: "#333",
                    fontWeight: "bold",
                    fontSize: "12px",
                  }}
                >
                  Crates: {item.CRATES}
                </td>
                <td
                  style={{
                    padding: "5px",
                    color: "#555",
                    fontSize: "12px",
                    fontWeight: "bold",
                  }}
                >
                  Packets: {item.PKT}
                </td>
                <td
                  style={{
                    padding: "5px",
                    color: "#333",
                    fontWeight: "bold",
                    fontSize: "12px",
                  }}
                >
                  Rate: {item.RATE}
                </td>
                <td
                  style={{
                    padding: "5px",
                    color: "#555",
                    fontSize: "12px",
                    fontWeight: "bold",
                  }}
                >
                  Amount: {item.AMOUNT}
                </td>
              </tr>
            </tbody>
          </table>
        ))} */}
        {rows && rows.length > 0 && (
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              border: "1px solid #ddd",
              marginBottom: "20px",
            }}
          >
            <thead>
              <tr
                style={{
                  backgroundColor: "#f8f8f8",
                  borderBottom: "2px solid #ddd",
                }}
              >
                <th
                  style={{
                    padding: "5px",
                    fontSize: "12px",
                    textAlign: "left",
                  }}
                >
                  Packet Name
                </th>
                <th
                  style={{
                    padding: "5px",
                    fontSize: "12px",
                    textAlign: "left",
                  }}
                >
                  Liters
                </th>
                {/* <th
                  style={{
                    padding: "5px",
                    fontSize: "12px",
                    textAlign: "left",
                  }}
                >
                  Crates
                </th> */}
                <th
                  style={{
                    padding: "5px",
                    fontSize: "12px",
                    textAlign: "left",
                  }}
                >
                  Packets
                </th>
                <th
                  style={{
                    padding: "5px",
                    fontSize: "12px",
                    textAlign: "left",
                  }}
                >
                  Rate
                </th>
                <th
                  style={{
                    padding: "5px",
                    fontSize: "12px",
                    textAlign: "left",
                  }}
                >
                  Amount
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((item) => (
                <tr key={item.key} style={{ borderBottom: "1px solid #ddd" }}>
                  <td style={{ padding: "5px", fontSize: "12px" }}>
                    {item.PACKET_NAME}
                  </td>
                  <td style={{ padding: "5px", fontSize: "12px" }}>
                    {item.LITERS}
                  </td>
                  {/* <td style={{ padding: "5px", fontSize: "12px" }}>
                    {item.CRATES}
                  </td> */}
                  <td style={{ padding: "5px", fontSize: "12px" }}>
                    {item.PKT}
                  </td>
                  <td style={{ padding: "5px", fontSize: "12px" }}>
                    {item.RATE}
                  </td>
                  <td style={{ padding: "5px", fontSize: "12px" }}>
                    {item.AMOUNT}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
